import React, { useEffect } from 'react';
import Routes from '../src/routes';
import GlobalStyle from './global';

export default function App() {
    useEffect(() => {
        changeTheme();
    }, []);

    async function changeTheme() {
        if (localStorage.getItem('theme') === 'dark') {
            document.body.classList.add('dark-theme');
        } else if (localStorage.getItem('theme') === 'light') {
            document.body.classList.remove('dark-theme');
        } else {
            localStorage.setItem('theme', 'light');
        }
    }

    window.onstorage = () => {
        changeTheme();
    };

    return (
        <>
            <Routes />
            <GlobalStyle />
        </>
    );
}
